<!-- <app-breadcrumbs title="DASHBOARD" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs> -->

<!-- CRN_20250926 - Retain for future use -->
<!-- {{viewport?.width}}x{{viewport?.height}} -->

<div class="page-sticky-header">
  @if(showTemplateMenuItems && (!isPlatformModeInview || platformInviewMode !== 'platform')) {
    <div class="row mb-3 pb-1">
      <div class="col-12">
        <div class="d-flex align-items-lg-center flex-lg-row flex-column">
          <!--
          <div class="flex-grow-1">
            <h4 class="fs-16 mb-1">@if(showTitle){<div>{{title}}</div>}</h4>
            <p class="text-muted mb-0">@if(showSubTitle){<div>{{subTitle}}</div>}</p>
          </div>
          -->
          <div class="mt-3 mt-lg-0">
            <div class="row g-3 mb-0 align-items-center">

              <div class="col-sm-auto">
                <div class="input-group">
                  <input class="form-control flatpickr-input" type="text" mwlFlatpickr [(ngModel)]="currentDate" [altInput]="false" [convertModelValue]="true" [dateFormat]="'d M, Y'" mode="range">
                  <div class="input-group-text bg-primary border-primary text-white"><i class="ri-calendar-2-line"></i></div>
                </div>
              </div>

              <div class="col-auto">
                <a routerLink="/ecommerce/add-product">
                  <button type="button" class="btn btn-soft-success"><i class="ri-add-circle-line align-middle me-1"></i> Add Product</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <div
    [ngClass]="(titlesEmbedCompanyDropDown && titlesEmbedDateDropDown) ? null : (titlesUseSureSimBlue ? 'rounded' : 'border rounded')"
    [ngStyle]="(titlesEmbedCompanyDropDown && titlesEmbedDateDropDown) ? null : (titlesUseSureSimBlue ? { 'border': '1px solid #5563a0' } : {})"
  >
    <div class="row mb-0">
      <div class="col-12">
        <div
          class="alert border-0 mb-0 py-3 ps-3 pe-2 d-flex align-items-center dashboard-header-bar"
              role="alert"
              [ngStyle]="{
                'background-color': titlesUseSureSimBlue ? '#5563a0' : '#e9ecf1',
                'color': titlesUseSureSimBlue ? 'white' : 'black'
              }"
            >
              <div class="d-flex align-items-center flex-grow-1 dashboard-header-branding">
                @if (testMode && curUser.systemAdmin) {
                  <img
                    alt="SureSIM Test"
                    class="me-3"
                    height="45"
                    src="assets/images/SureSIM-Test-Logo-Light-109.png"
                    style="cursor: pointer"
                    (click)="curUser.systemAdmin && testIconClick()"
                  />
                }

                @if (titlesUseSureSimBlue && (!curUser.branded || curUser.isUtelize)) {
                  <img
                    alt="SureSIM Logo"
                    class="me-4"
                    [class.logo-grow-in]="sureSimLogoGrow"
                    [height]="isPlatformModeInview ? 45 : 45"
                    [src]="isPlatformModeInview ? 'assets/images/myinview-logo.png' : 'assets/images/SureSIM-Logo-Light-109.png'"
                    [style.cursor]="showDateSelectorViaIconClick || curUser.systemAdmin ? 'pointer' : 'default'"
                    (click)="(showDateSelectorViaIconClick || curUser.systemAdmin) && showDateSelectorClick()"
                  />
                }
            
                <div class="d-flex flex-column">
                  <h4 class="fs-16 mb-1" [class.text-grow-in]="sureSimLogoGrow" [style.color]="titlesUseSureSimBlue ? 'white' : 'black'">
                    @if (showTitle) { {{title}} }
                  </h4>
                  <p class="mb-0" [class.text-grow-in]="sureSimLogoGrow" [ngClass]="{ 'text-muted': !titlesUseSureSimBlue }">
                    @if (showSubTitle) { {{subTitle}} }
                  </p>
                </div>
            
                @if (activityEnabled || showTemplateMenuItems) {
                  <span class="position-absolute top-50 end-0 translate-middle-y px-2">
                    <button
                      type="button"
                      class="btn btn-soft-info btn-icon waves-effect waves-light"
                      (click)="toggleActivity()"
                    >
                      <i class="ri-pulse-line"></i>
                    </button>
                  </span>
                }
              </div>
              @if (titlesEmbedCompanyDropDown) {
                <div style="width: 500px; margin-right: 0.5rem;" class="ms-auto">
                  <app-dropdown-company
                    *ngIf="dropdownReady"
                    class="ms-auto"
                    [hierarchyFormatting]="superHierarchyEnabled"
                    [initialCompanyId]="filterCompanyID"
                    (selectOnChangeEvent)="companyDropDownOnChange($event)"
                  ></app-dropdown-company>
                </div>
              }

              @if (titlesEmbedDateDropDown && (showDateSelector || _showDateSelector)) {
                <div style="margin-right: 0.5rem;">
                  <app-dropdown-date
                    [dateFormat]="filterDateFormat"
                    [initialDate]="filterDate"
                    [monthSelector]="true"
                    title="Month"
                    (selectOnChangeEvent)="dateFilterChanged($event)"
                  ></app-dropdown-date>
                </div>
              }
            </div>
          </div>
        </div>
        
        @if (!titlesEmbedCompanyDropDown || (!titlesEmbedDateDropDown && (showDateSelector || _showDateSelector))) {
          <div class="mb-3 px-2 d-flex justify-content-end align-items-end gap-3">
            @if (!titlesEmbedCompanyDropDown) {
              <div style="width: 500px">
                <app-dropdown-company
                  [hierarchyFormatting]="superHierarchyEnabled"
                  [initialCompanyId]="filterCompanyID"
                  (selectOnChangeEvent)="companyDropDownOnChange($event)"
                ></app-dropdown-company>
              </div>
            }

            @if (!titlesEmbedDateDropDown && (showDateSelector || _showDateSelector)) {
              <app-dropdown-date
                [dateFormat]="filterDateFormat"
                [initialDate]="filterDate"
                [monthSelector]="true"
                title="Month"
                (selectOnChangeEvent)="dateFilterChanged($event)"
              ></app-dropdown-date>
            }
          </div>
        }
      </div>
</div>

<div class="row mt-2">
  <div class="col">
    <div class="h-100">
      @if(isPlatformModeInview && platformInviewMode==='platform') {
        <app-widget-row-platform></app-widget-row-platform>
      }

      @if(!isPlatformModeInview || platformInviewMode !== 'platform') {
        <div class="row">
        <div class="col-12">
          <label class="label-spacer1"></label>
        </div>
        </div>
        
        <div class="stat-strip-flex d-flex mb-3">
        <div class="stat-content flex-grow-1">
          <div class="row g-3 m-0 stat-row-no-gutter">
            
            @if (widgetsExpanded) {
              <app-widget-row-total-costs #widgetRowTotalCosts
                [allowContainerClose]="allowContainerClose"
                [containerTitle]="widgetRowTitleTotalCosts"
                [useContainer]="true"
              ></app-widget-row-total-costs>
              
              <app-widget-row-licences #widgetRowLicences
                [allowContainerClose]="allowContainerClose"
                [containerTitle]="widgetRowTitleLicences"
                [useContainer]="true"
              ></app-widget-row-licences>

              <app-widget-row-alerts #widgetRowAlerts
                [allowContainerClose]="allowContainerClose"
                [containerTitle]="widgetRowTitleAlerts"
                [useContainer]="true"
              ></app-widget-row-alerts>
            } @else {            
              <ng-container [ngSwitch]="selectedWidgetGroupKey">
              
                <ng-container *ngIf="selectedWidgetGroupKey==='TotalCosts'">
                  <app-widget-row-total-costs #widgetRowTotalCosts></app-widget-row-total-costs>
                </ng-container>
              
                <ng-container *ngIf="selectedWidgetGroupKey==='TotalSimsUsageCosts'">
                  <app-widget-row-usage #widgetRowUsage></app-widget-row-usage>
                </ng-container>
              
                <ng-container *ngIf="selectedWidgetGroupKey==='TotalLicences'">
                  <app-widget-row-licences #widgetRowLicences
                    [showTotalLicenceCosts]="true"
                  ></app-widget-row-licences>
                </ng-container>
              
                <ng-container *ngIf="selectedWidgetGroupKey==='TotalAlerts'">
                  <app-widget-row-alerts #widgetRowAlerts></app-widget-row-alerts>
                </ng-container>
              
              </ng-container>
            }
          </div>
        </div>
      
        @if (showWidgetStepSelector) {
          <div class="stat-rail-col">
            <div class="stat-rail"></div>

            <button
              type="button"
              class="stat-rail-btn stat-rail-btn--toggle"
              (click)="widgetExpandCollapseClick()"
              [attr.data-bs-toggle]="'tooltip'"
              [attr.data-bs-placement]="'left'"
              [attr.data-bs-custom-class]="'ss-tooltip'"
              [attr.data-bs-title]="widgetsExpanded ? 'Collapse Widgets' : 'Expand Widgets'"
              [attr.aria-label]="widgetsExpanded ? 'Collapse Widgets' : 'Expand Widgets'">
              <i [ngClass]="widgetsExpanded ? 'bi bi-arrows-angle-contract' : 'bi bi-arrows-angle-expand'"></i>
            </button>

            <button #railBtn
              *ngIf="widgetGroupSelectorCanUp && !widgetsExpanded"
              type="button"
              class="stat-rail-btn stat-rail-btn--up"
              (click)="onWidgetGroupSelectorUp()"
              [attr.data-bs-toggle]="'tooltip'"
              [attr.data-bs-placement]="'left'"
              [attr.data-bs-custom-class]="'ss-tooltip'"
              [attr.data-bs-title]="selectedWidgetGroupPrevLabel ?? ''"
              [attr.aria-label]="'Previous: ' + (selectedWidgetGroupPrevLabel ?? '')">
              <i class="ri-arrow-up-s-line"></i>
            </button>
            
            <button #railBtn
              *ngIf="widgetGroupSelectorCanDown && !widgetsExpanded"
              type="button"
              class="stat-rail-btn stat-rail-btn--down"
              (click)="onWidgetGroupSelectorDown()"
              [attr.data-bs-toggle]="'tooltip'"
              [attr.data-bs-placement]="'left'"
              [attr.data-bs-custom-class]="'ss-tooltip'"
              [attr.data-bs-title]="selectedWidgetGroupNextLabel ?? ''"
              [attr.aria-label]="'Next: ' + (selectedWidgetGroupNextLabel ?? '')">
              <i class="ri-arrow-down-s-line"></i>
            </button>
          </div>
        }
        </div>
  
        @if(showTemplateMenuItems){
        <div class="row">
          @for (stat of statData; track $index) {
            <div class="col-xl-3 col-md-6">
              <app-stat
                [icon]="stat.icon"
                [link]="stat.link"
                [percentage]="stat.percentage"
                [profit]="stat.profit"
                [profitUpIsGood]="stat.profitUpIsGood"
                [subTitle]="stat.subTitle"
                [title]="stat.title"
                [value]="stat.value"
              >
            </app-stat>
            </div>
          }
        </div>
        }
  
        @if(showTemplateMenuItems){
        <div class="row">
          <div class="col-xl-6">
            <div class="card">
              <div class="card-header align-items-center d-flex">
                <h4 class="card-title mb-0 flex-grow-1">Best Selling Products</h4>
                <div class="flex-shrink-0">
                  <div class="dropdown card-header-dropdown" ngbDropdown>
                    <a class="text-reset dropdown-btn arrow-none" href="javascript: void(0);" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                      <span class="fw-semibold text-uppercase fs-12">Sort by: </span><span class="text-muted">Today<i class="mdi mdi-chevron-down ms-1"></i></span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                      <a class="dropdown-item" href="javascript: void(0);">Today</a>
                      <a class="dropdown-item" href="javascript: void(0);">Yesterday</a>
                      <a class="dropdown-item" href="javascript: void(0);">Last 7 Days</a>
                      <a class="dropdown-item" href="javascript: void(0);">Last 30 Days</a>
                      <a class="dropdown-item" href="javascript: void(0);">This Month</a>
                      <a class="dropdown-item" href="javascript: void(0);">Last Month</a>
                    </div>
                  </div>
                </div>
              </div>
                                                                                      
              <div class="card-body">
                <div class="table-responsive table-card">
                  <app-best-selling [BestSelling]="bestSelling"></app-best-selling>
                </div>
                                                                                      
                <div class="align-items-center mt-4 pt-2 justify-content-between d-flex">
                  <div class="col-sm">
                    <div class="text-muted">Showing<span class="fw-semibold">4</span> of <span class="fw-semibold">125</span> Results</div>
                  </div>
                  <div class="col-sm-auto">
                    <ul class="pagination pagination-separated pagination-sm justify-content-center justify-content-sm-start mb-0">
                      <li class="page-item disabled">
                        <a href="javascript:void(0);" class="page-link">←</a>
                      </li>
                      <li class="page-item">
                        <a href="javascript:void(0);" class="page-link">1</a>
                      </li>
                      <li class="page-item active">
                        <a href="javascript:void(0);" class="page-link">2</a>
                      </li>
                      <li class="page-item">
                        <a href="javascript:void(0);" class="page-link">3</a>
                      </li>
                      <li class="page-item">
                        <a href="javascript:void(0);" class="page-link">→</a>
                      </li>
                    </ul>
                  </div>
                </div>
                                                                                      
              </div>
            </div>
          </div>
                                                                                      
          <div class="col-xl-6">
            <div class="card card-height-100">
              <div class="card-header align-items-center d-flex">
                <h4 class="card-title mb-0 flex-grow-1">Top Sellers</h4>
                <div class="flex-shrink-0">
                  <div class="dropdown card-header-dropdown" ngbDropdown>
                    <a class="text-reset dropdown-btn arrow-none" href="javascript: void(0);" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                      <span class="text-muted">Report<i class="mdi mdi-chevron-down ms-1"></i></span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                      <a class="dropdown-item" href="javascript: void(0);">Download Report</a>
                      <a class="dropdown-item" href="javascript: void(0);">Export</a>
                      <a class="dropdown-item" href="javascript: void(0);">Import</a>
                    </div>
                  </div>
                </div>
              </div>
                                                                                      
              <div class="card-body">
                <div class="table-responsive table-card">
                  <app-top-selling [TopSelling]="topSelling"></app-top-selling>
                </div>
                                                                                      
                <div class="align-items-center mt-4 pt-2 justify-content-between d-flex">
                  <div class="col-sm">
                    <div class="text-muted">Showing<span class="fw-semibold">4</span> of <span class="fw-semibold">125</span> Results
                    </div>
                  </div>
                  <div class="col-sm-auto">
                    <ul class="pagination pagination-separated pagination-sm justify-content-center justify-content-sm-start mb-0">
                     <li class="page-item disabled">
                       <a href="javascript:void(0);" class="page-link">←</a>
                     </li>
                     <li class="page-item">
                       <a href="javascript:void(0);" class="page-link">1</a>
                     </li>
                     <li class="page-item active">
                       <a href="javascript:void(0);" class="page-link">2</a>
                     </li>
                     <li class="page-item">
                       <a href="javascript:void(0);" class="page-link">3</a>
                     </li>
                     <li class="page-item">
                       <a href="javascript:void(0);" class="page-link">→</a>
                     </li>
                    </ul>
                  </div>
                </div>
                                                                                      
              </div>
            </div>
          </div>
        </div>
        }  
                                                                                      
        <div class="row">
        @if(showTemplateMenuItems) {
          <div class="col-xl-4">
            <div class="card card-height-100">
              <div class="card-header align-items-center d-flex">
                <h4 class="card-title mb-0 flex-grow-1">eSIM Sales</h4>
                <div class="flex-shrink-0">
                  <div class="dropdown card-header-dropdown" ngbDropdown>
                    <a class="text-reset dropdown-btn arrow-none" href="javascript: void(0);" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                      <span class="text-muted">Report<i class="mdi mdi-chevron-down ms-1"></i></span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                      <a class="dropdown-item" href="javascript: void(0);">Download Report</a>
                      <a class="dropdown-item" href="javascript: void(0);">Export</a>
                      <a class="dropdown-item" href="javascript: void(0);">Import</a>
                    </div>
                  </div>
                </div>
              </div>
                                                                                      
              <div class="card-body">
                <apx-chart class="apex-charts" dir="ltr" [series]="salesCategoryChart.series" [labels]="salesCategoryChart.labels" [chart]="salesCategoryChart.chart" [legend]="salesCategoryChart.legend" [stroke]="salesCategoryChart.stroke" [dataLabels]="salesCategoryChart.dataLabels" [colors]="salesCategoryChart.colors" dir="ltr"></apx-chart>
              </div>
            </div>
          </div>
        } @else if (showCostsPerZone &&
                    costsPerZoneChart != undefined &&
                    (this.costsPerZoneTotalCosts.length>0 || showCostsPerZoneIfNoData || this.loadingChart)) {
          <div
            class="custom-col-1"
            [style.--donut-0-dynamic-width]="donut0DynamicWidth"
          >
            <div class="card card-height-100">
              <div class="card-header align-items-center d-flex">
                <h4 class="card-title mb-0 flex-grow-1">Costs per Zone</h4>
                @if(showTemplateMenuItems) {
                  <div class="flex-shrink-0">
                    <div class="dropdown card-header-dropdown" ngbDropdown>
                      <a class="text-reset dropdown-btn arrow-none" href="javascript: void(0);" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                        <span class="text-muted">Report<i class="mdi mdi-chevron-down ms-1"></i></span>
                      </a>
                      <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                        <a class="dropdown-item" href="javascript: void(0);">Download Report</a>
                        <a class="dropdown-item" href="javascript: void(0);">Export</a>
                        <a class="dropdown-item" href="javascript: void(0);">Import</a>
                      </div>
                    </div>
                  </div>
                }
              </div>
              @if(this.loadingChart) {
                <div class="d-flex align-items-end justify-content-between mt-4 ms-4">
                  <div>
                    <p class="fw-medium text-muted text-truncate mb-4"><i>Loading...</i></p>
                  </div>
                </div>
              }                                                               
              <div class="card-body">
                <apx-chart
                  [chart]="costsPerZoneChart.chart"
                  class="apex-charts"
                  [colors]="costsPerZoneChart.colors" dir="ltr"
                  [dataLabels]="costsPerZoneChart.dataLabels"
                  dir="ltr"
                  [labels]="costsPerZoneChart.labels"
                  [legend]="costsPerZoneChart.legend"
                  [series]="costsPerZoneChart.series"
                  [stroke]="costsPerZoneChart.stroke"
                  [tooltip]="costsPerZoneChart.tooltip"
                ></apx-chart>
              </div>
            </div>
          </div>
        }
        
        @if(showTemplateMenuItems) {
          <div class="col-xl-9">        
            <div class="card">
              <div class="card-header align-items-center d-flex">
                <h4 class="card-title mb-0 flex-grow-1">Recent Orders</h4>
                <div class="flex-shrink-0">
                  <button type="button" class="btn btn-soft-info btn-sm">
                    <i class="ri-file-list-3-line align-middle"></i>
                    Generate Report
                  </button>
                </div>
              </div>
                                                                                      
              <div class="card-body">
                <div class="table-responsive table-card">
                  <app-recent-orders [Recentelling]="recentelling"></app-recent-orders>
                </div>
              </div>
            </div>
          </div>
        }
        </div>
  
        <div class="row">
        <div class="col-12">
          <div #bottomContainer class="border border-success rounded">
            <div class="row">
              <div class="col-12">
                <div class="alert border-0 alert-primary d-flex justify-content-between align-items-center" role="alert">
                  <strong>{{interactiveUserGridShow ? "SureSIM Subscribers" : "Top Users with Most Cost"}}</strong>
                  <div class="d-flex align-items-center gap-2">
                    <div class="form-check form-switch form-switch-md d-flex align-items-center ps-0">
                      <label class="form-check-label mb-0 me-3" for="extend-view-check-box">
                        <span class="text-muted small">Extend View</span>
                      </label>
                      <input
                        class="form-check-input"
                        id="extend-view-check-box"
                        [(ngModel)]="extendView"
                        role="switch"
                        style="margin-left:0"
                        type="checkbox"
                        (change)="extendViewCheckboxChange()"
                      >
                    </div>
                    @if (interactiveUserGrid) {
                      <div class="form-check form-switch form-switch-md d-flex align-items-center ps-0">
                        <label class="form-check-label mb-0 me-3" for="interactive-grid-check-box">
                          <span class="text-muted small">Interactive Grid</span>
                        </label>
                        <input
                          class="form-check-input"
                          id="interactive-grid-check-box"
                          [(ngModel)]="interactiveUserGridShow"
                          role="switch"
                          style="margin-left:0"
                          type="checkbox"
                          (change)="interactiveGridCheckboxChange()"
                        >
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
                    
            <div class="row px-2">
                
              <div [hidden]="!interactiveUserGridShow">
                <app-devices-allocated-content-shared #devicesAllocated
                  [hostComponent]="constructor.name"
                ></app-devices-allocated-content-shared>
              </div>
              
              <div [hidden]="interactiveUserGridShow" class="users-most-cost-container">
                <div
                  [className]="!showCostsPerZone || (this.costsPerZoneTotalCosts.length==0 && !showCostsPerZoneIfNoData && !this.loadingChart) ? 'col-xl-12' : 'custom-col-2'"
                  [style.--grid-0-dynamic-width]="grid0DynamicWidth"
                >
                  <app-users-most-cost
                    [loading]="loadingUsersWithMostCost"
                    [userWithMostCost]="userWithMostCost"
                    (refreshData)="refreshUserWithMostCost()"
                  ></app-users-most-cost>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        </div>
      }
    </div>
                                                                                    
  </div>
</div>
